import { UseI18nHook } from "@core/i18n/i18n";
import { UseNavigationHook } from "@core/routing/use-navigate";
import { Notification } from "@domain/notification/notification";
import { RoutesPath } from "@ui/navigation/routes";

export class PtAccountValidatedNotification extends Notification {
	private get data() {
		return undefined;
	}

	format({ format }: UseI18nHook): string {
		return format("global.notifications.ptAccount.validated");
	}

	onClick(navigate: UseNavigationHook): void {
		navigate(RoutesPath.NotificationCenter);
	}
}
